<template>
  <a-layout class="sc-layout-container">
    <a-layout>
      <sc-side />
      <a-layout style="padding: 0 24px 24px">
        <a-layout-content class="content">
          <router-view :key="$route.path" />
        </a-layout-content>
      </a-layout>
    </a-layout>
    <sc-windows ref="windows" />
  </a-layout>
</template>
<script lang="ts">
import ScSide from './component/ScSide.vue';
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'Home',
  components: {
    ScSide,
  },
  mounted() {
    this.$windows.setWindows(this.$refs.windows);
  },
  data() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.sc-layout-container {
  height: 100%;

  .content {
    display: flex;
    flex-direction: column;
  }
}
</style>
